import loadable from '@loadable/component';

const AdminLoadable = loadable(() => import(/* webpackChunkName: 'admin' */ './Admin'));

const Admin = (props: any) => <AdminLoadable {...props} />;

export default Admin;
